import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import ServicesPage from './pages/ServicesPage';
import PartnersPage from './pages/PartnersPage';
import CareersPage from './pages/CareersPage';
import DriversPage from './pages/DriversPage';
import AdminPage from './pages/AdminPage';
import StateLandingPage from './pages/StateLandingPage';
import { Toaster } from './components/ui/toaster';
import { initAnalytics, trackPageView } from './lib/analytics';

const RouteTracker = () => {
  const loc = useLocation();
  useEffect(() => {
    trackPageView(loc.pathname + loc.search);
  }, [loc.pathname, loc.search]);
  return null;
};

function App() {
  useEffect(() => {
    initAnalytics();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <RouteTracker />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/partners" element={<PartnersPage />} />
          <Route path="/careers" element={<CareersPage />} />
          <Route path="/drivers" element={<DriversPage />} />
          <Route path="/careers/drivers" element={<DriversPage />} />
          {['texas','florida','california','new-york','georgia','arizona','illinois','nevada'].map(slug => (
            <Route key={slug} path={`/car-shipping-${slug}`} element={<StateLandingPage slug={slug} />} />
          ))}
          {/* Removed pages — redirect old URLs */}
          <Route path="/tracking" element={<Navigate to="/" replace />} />
          <Route path="/broker-credit-check" element={<Navigate to="/" replace />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
